export const createOrderQuery = (field, orderByDirection) => {
    switch (field) {
        case 'Vendor':
            return [{ field: 'Product.Vendor', direction: orderByDirection }];
        case 'ProductSerial':
            return [{ field: 'Product.SerialNumber', direction: orderByDirection }];
        case 'Username':
            return [{ field: 'User.Username', direction: orderByDirection }];
        case 'ProductType':
            return [{ field: 'Product.Type', direction: orderByDirection }];
        default:
            return [{ field: field, direction: orderByDirection }];
    }
};